import React, { useEffect, useState, useContext, useRef } from "react";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Card from "react-bootstrap/Card";
import { confirmAlert } from "react-confirm-alert";
import "antd/dist/antd.min.css";
import { Modal } from "react-bootstrap";
import { DataGrid } from "@material-ui/data-grid";
import toast from "react-hot-toast";
import { makeStyles } from "@material-ui/core/styles";
import Badge from "react-bootstrap/Badge";
import "antd/dist/antd.min.css";
import { DatePicker } from "antd";
//Global State import
import { useAtom } from "jotai";
import { gbState } from "../../../../components/shared/GlobalState";

//Context import
import AuthContext from "../../../../components/shared/Context";
// import ExcelDownloader from "./ExcelDownloader"; // Import the ExcelDownloader component

import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

const { RangePicker } = DatePicker;

const ListTCLocalPurchasesChild = () => {
  let navigate = useNavigate();
  const { loggedInUserDetails } = useContext(AuthContext);

  const [data, setData] = useState([]);
  const [unfilteredData, setUnfilteredData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [deliveryInfo, setDeliveryInfo] = useState(false);
  const searchRef = useRef();

  //Error Logging Service
  const [
    { errorLogApi, dateFormatter, _calculateDaysLeft, _checkCalculateDaysLeft },
  ] = useAtom(gbState);

  const getDataFromServer = () => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    let urlLink = `${process.env.REACT_APP_API_URL}/tcpurchase/`;

    axios
      .get(urlLink, config)
      .then((res) => {
        const oldData = res.data;
        //console.log(oldData);
        const updatedData = oldData.map((data) => {
          //   console.log(data.purchase_inventory.product_id.products);
          return {
            ...data,
            id: data._id,
            stock_type: data?.p_register?.stock_type, //newly added
            product_code: data?.p_register?.product_id?.products?.item_code,
            product_name: data?.p_register?.product_id?.products?.product_name,
            product_expiry: data?.p_register?.expiry_date,
            expiry_status: _checkCalculateDaysLeft(
              data?.p_register?.expiry_date
            ),
            local_po_date: data?.p_register?.local_po_date,
            date_for_filter: data?.p_register?.local_po_date,
            local_po_number: data?.p_register?.local_po_number,
            quantity: data?.p_register?.quantity,
            tc_name: data?.p_register?.tc_id?.tcenters?.name_tc,
            state: data?.p_register?.state,
            allotment_recieved_status:
              data?.p_register?.allotment_recieved_status,
            comments: data?.p_register?.comments,
          };
        });
        //console.log(updatedData);
        setData(updatedData);
        setUnfilteredData(updatedData);
      })
      .catch((err) => console.log("error", err));
  };

  useEffect(() => {
    getDataFromServer();
  }, []);

  const handleDelete = (id) => {
    confirmAlert({
      title: "",
      message: "Are you sure to delete this Product ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteRecord(id),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const deleteRecord = (id) => {
    let userToken = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${userToken}` },
    };
    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/tcpurchase/lpo-delete/${id}`,
        config
      )
      .then((response) => {
        getDataFromServer();
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };

  const revertRecord = (row) => {
    confirmAlert({
      title: "",
      message: `Are you sure to delete ${row.product_name} of quantity ${row.quantity} having allocation id ${row.sale_code} from your inventory ?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => revertRecordHandle(row.id),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });

    const revertRecordHandle = (id) => {
      let userToken = localStorage.getItem("token");
      const config = {
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}/tcpurchase/revert`,
        headers: { Authorization: `Bearer ${userToken}` },
        data: { purchase_id: id },
      };
      axios(config)
        .then((response) => {
          getDataFromServer();
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message);
        });
    };
  };

  const useStyles = makeStyles(() => ({
    multiLineCell: {
      display: "flex",
      wordBreak: "keep-all",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      lineHeight: "1.2rem",
      height: "100%",
    },
    customRow: {
      height: "75px", // Increase the row height as needed
    },
  }));

  const calculateDaysLeft = (date) => {
    // Convert the given date string to a Date object
    const givenDate = new Date(date);

    // Calculate the difference between the current date and the given date in milliseconds
    const timeDiff = givenDate.getTime() - new Date().getTime();

    // Convert milliseconds to days and round down to the nearest integer
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    // Update the state with the number of days left
    //setDaysLeft(days);
    return days;
  };

  const MultiLineCellRenderer = (params) => {
    const classes = useStyles();
    const daysLeft = calculateDaysLeft(params.row.product_expiry);

    return (
      <Tooltip title={params.row.product_name}>
        <div className={classes.multiLineCell}>
          <span id="content1" className="text-bold">
            {params.row.product_name}
          </span>
          <span id="content2">
            <small className="small-font-size">
              {params.row.product_code}&nbsp;{" "}
            </small>
          </span>
        </div>
      </Tooltip>
    );
  };

  const columns = [
    {
      field: "Action",
      headerName: "Action",
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      width: 80,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="editiConContainer">
            <Tooltip title="View PO">
              <a onClick={() => viewRecord(params.row)}>
                <i
                  className="mdi mdi-eye-circle-outline"
                  style={{ fontSize: "15px", color: "black" }}
                ></i>
              </a>
            </Tooltip>
            <Tooltip title="Edit PO">
              <div
                onClick={() => navigate("/update-lpo", { state: params.row })}
              >
                <i
                  className="mdi mdi-square-edit-outline"
                  style={{ fontSize: "15px", color: "grey", cursor: "pointer" }}
                ></i>
              </div>
            </Tooltip>
            <Tooltip title="Delete PO">
              <div onClick={() => handleDelete(params.row._id)}>
                <i
                  className="mdi mdi-trash-can-outline"
                  style={{ fontSize: "15px", color: "red", cursor: "pointer" }}
                ></i>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "product_name",
      headerName: "Product",
      width: 220,
      renderCell: MultiLineCellRenderer,
    },
    {
      field: "local_po_date",
      headerName: "Date",
      filterable: false,
      disableColumnMenu: true,
      width: 120,
      align: "center",
    },
    {
      field: "local_po_number",
      headerName: "Local PO",
      filterable: false,
      disableColumnMenu: true,
      width: 160,
      align: "center",
    },

    {
      field: "quantity",
      headerName: "Qty",
      filterable: false,
      disableColumnMenu: true,
      width: 120,
      align: "center",
    },

    {
      field: "expiry_status",
      headerName: "Expiry",
      width: 120,
      renderCell: (params) =>
        isNaN(params.row.expiry_status) ? (
          <Badge bg="danger">Expired</Badge>
        ) : (
          <Badge bg="success">( {params.row.expiry_status} ) days left</Badge>
        ),
    },
    {
      field: "stock_type",
      headerName: "Stock Type",
      width: 140,
      filterable: false,
      disableColumnMenu: true,
      align: "left",
      renderCell: (params) =>
        params?.row?.stock_type ? (
          <Badge bg="primary" style={{ width: "100%", display: "block" }}>
            LOCAL PURCHASE
          </Badge>
        ) : (
          <Badge bg="success" style={{ width: "100%", display: "block" }}>
            STATE ALLOCATION
          </Badge>
        ),
    },
    {
      field: "tc_name",
      headerName: "TC Name",
      width: 150,
    },

    {
      field: "state",
      headerName: "State",
      filterable: false,
      disableColumnMenu: true,
      width: 110,
    },
  ];

  const viewRecord = (rec) => {
    setCurrentRecord(rec);
    setOpenModal(true);
  };
  //   console.log(data);

  const handleSearch = (e) => {
    //console.log("Search Value...", e);

    if (e) {
      setData(
        unfilteredData.filter((item) => {
          return (
            item?.product_code?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.expiry_status
              ?.toString()
              ?.toLowerCase()
              .includes(e?.toLowerCase()) ||
            item?.product_name?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.company_name?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.sale_code?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.state?.toLowerCase().includes(e?.toLowerCase())
          );
        })
      );
    } else {
      getDataFromServer();
      setData(unfilteredData);
    }
  };

  const clearSearch = () => {
    searchRef.current.value = null;
    getDataFromServer();
  };

  const handleDateChange = (dates, dateStrings) => {
    if (dates) {
      const [start, end] = dates;
      setData(
        unfilteredData.filter((item) => {
          const visitDate = new Date(item.date_for_filter);
          return visitDate >= start && visitDate <= end;
        })
      );
    } else {
      setData(unfilteredData);
    }
  };

  const handleDataRefresh = () => {
    getDataFromServer();
  };

  //Bulk Delete function
  const handleSelectionChange = (selectionModel) => {
    // `selectionModel` will be an array of IDs of selected rows
    setSelectedIds(selectionModel);
  };

  const deleteMultipleRecords = () => {
    let inputCode = "";
    if (!selectedIds?.length) return toast.error("Please select Record(s)");

    confirmAlert({
      title: "",
      message: "Are you sure to delete record(s) ?",
      childrenElement: () => (
        <div>
          {/* Use the key here */}
          <input
            type="text"
            placeholder="Type Code..."
            className="mt-2"
            onChange={(e) => (inputCode = e.target.value)} // Direct assignment
          />
        </div>
      ),
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteRecordInBulk(inputCode),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const deleteRecordInBulk = (inputCode) => {
    if (!inputCode) return toast.error("Please enter a valid code!");

    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/tcpurchase/delete/bulk`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ids: selectedIds, secret_code: inputCode },
    };
    if (selectedIds.length > 0) {
      axios(config)
        .then(function (response) {
          getDataFromServer();
          toast.success("Stock Deleted Successfully.");
        })
        .catch(function (error) {
          errorLogApi(error, "PWStockDeleteMany", "/delete/bulk");
          toast.error(JSON.stringify(error.response.data.message));
        });
    }
  };

  return (
    <div>
      <span className="">
        <h3>Manage Local Purchase Orders (LPO)</h3>
      </span>
      <div className="float-end mb-2">
        <button className="btn btn-secondary me-2" onClick={() => navigate(-1)}>
          <i className="mdi mdi-arrow-left" />
          Back
        </button>
        <button
          className="btn btn-success me-2"
          onClick={() => navigate("/add-lpo")}
        >
          <i className="mdi mdi-plus" />
          Create New LPO
        </button>
        <button className="btn btn-primary " onClick={handleDataRefresh}>
          <i className="mdi mdi-autorenew" />
        </button>
        {loggedInUserDetails?.force_delete === true && (
          <button
            className="btn btn-danger ms-2"
            onClick={deleteMultipleRecords}
          >
            <i className="mdi mdi-delete"></i>
          </button>
        )}
      </div>
      {/* <CheckboxComponent
        setData={setData}
        data={data}
        unfilteredData={unfilteredData}
      /> */}

      <div className="patientListSearch">
        <InputGroup className="mb-3">
          <InputGroup.Text id="basic-addon1">Filter</InputGroup.Text>
          <Form.Control
            placeholder="Product / State / Code / Company ..."
            aria-label="Search"
            aria-describedby="basic-addon1"
            name="searchPatients"
            ref={searchRef}
            onChange={(e) => handleSearch(e.target.value)}
          />
          <InputGroup.Text>
            <i
              className="mdi mdi-delete-outline"
              onClick={clearSearch}
              style={{ cursor: "pointer" }}
            ></i>
          </InputGroup.Text>
        </InputGroup>
      </div>
      <div className="dateFilter mb-3">
        Date Filter : <RangePicker onChange={handleDateChange} />
      </div>
      <DataGrid
        rows={data}
        disableSelectionOnClick
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10]}
        displayTitle="Purchases"
        checkboxSelection
        style={{ height: "60vh" }}
        onSelectionModelChange={handleSelectionChange}
      />

      {/* Modal Popup */}
      <Modal show={openModal} centered>
        <Modal.Header closeButton onClick={() => setOpenModal(false)}>
          <Modal.Title>Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalContent
            currentRecord={currentRecord}
            deliveryInfo={deliveryInfo}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

const ModalContent = ({ currentRecord, deliveryInfo }) => {
  const [{ dateFormatter, _calculateDaysLeft }] = useAtom(gbState);
  const daysLeft = _calculateDaysLeft(currentRecord.product_expiry);
  return (
    <div className="container-fluid">
      {!deliveryInfo && (
        <ModalCardComponent title="Product Details">
          <table class="table">
            <tbody>
              <tr>
                <th scope="row">LPO Date</th>
                <td>{currentRecord.local_po_date}</td>
              </tr>
              <tr>
                <th scope="row">LPO Number</th>
                <td>{currentRecord.local_po_number}</td>
              </tr>
              <tr>
                <th scope="row">Product Name</th>
                <td>{currentRecord.product_name}</td>
              </tr>
              <tr>
                <th scope="row">Product Code</th>
                <td>{currentRecord.product_code}</td>
              </tr>
              <tr>
                <th scope="row">Product Expiry</th>
                <td>
                  {dateFormatter(currentRecord.product_expiry)} &nbsp;&nbsp;
                  <b> {daysLeft} days left</b>
                </td>
              </tr>
              <tr>
                <th scope="row">Quantity</th>
                <td>{currentRecord.quantity}</td>
              </tr>
              <tr>
                <th scope="row">Unit Price</th>
                <td>{currentRecord.p_register.local_unit_price}</td>
              </tr>
              <tr>
                <th scope="row">TC Name</th>
                <td>{currentRecord.tc_name}</td>
              </tr>
              <tr>
                <th scope="row">State</th>
                <td>{currentRecord.state}</td>
              </tr>
              <tr>
                <th scope="row">Stock Type</th>
                <td>
                  {currentRecord.stock_type
                    ? "Local Purchase"
                    : "State Allocation"}
                </td>
              </tr>
              <tr>
                <th scope="row">Comments</th>
                <td>{currentRecord.comments}</td>
              </tr>
            </tbody>
          </table>
        </ModalCardComponent>
      )}
      {deliveryInfo && (
        <ModalCardComponent title="Delivery Details">
          <table class="table">
            <tbody>
              <tr>
                <th scope="row">Delivery Person</th>
                <td>{currentRecord?.p_register?.delivery_person}</td>
              </tr>
              <tr>
                <th scope="row">Delivery Mobile</th>
                <td>{currentRecord?.p_register?.delivery_mobile}</td>
              </tr>
              <tr>
                <th scope="row">Delivery Date</th>
                <td>
                  {
                    currentRecord?.p_register?.expected_date_of_delivery?.split(
                      "T"
                    )[0]
                  }
                </td>
              </tr>
              <tr>
                <th scope="row">Comments</th>
                <td>{currentRecord?.p_register?.comments}</td>
              </tr>
            </tbody>
          </table>
        </ModalCardComponent>
      )}
    </div>
  );
};

const ModalCardComponent = ({ title, children }) => {
  return (
    <Card style={{ width: "100%" }}>
      <Card.Header>
        <span className="card-title">
          <b>{title}</b>
        </span>
      </Card.Header>
      <Card.Body style={{ wordBreak: "break-word" }}>{children}</Card.Body>
    </Card>
  );
};

export default ListTCLocalPurchasesChild;
